<script>
    import Select from "svelte-select";
    import { createEventDispatcher, onMount } from "svelte";
    import AttentionMark from "../ui/AttentionMark.svelte";

    const dispatch = createEventDispatcher();

    export let translationNeeded;
    export let editLocale;
</script>

<div style="display:flex">
    {#if translationNeeded}
        <AttentionMark />
    {/if}
    <Select
        items={[
            { value: "de", label: "Deutsch" },
            { value: "en", label: "Englisch" },
            { value: "fr", label: "Französisch" },
        ]}
        value={editLocale}
        on:select={(event) => {
            editLocale = event.detail.value;
            dispatch("select", editLocale);
        }}
        isClearable={false}
        containerStyles="width: 128px; height: 30px; margin-bottom: 8px;"
        getSelectionLabel={(item) => item.label}
        labelIdentifier="label"
    />
</div>
